export const ALLOCATIONS_ROLES = ["Allocations.Viewer", "Allocations.Editor"] as const;

export type AllocationsViewerRole = (typeof ALLOCATIONS_ROLES)[number];

export const INSIGHTS_ROLES = ["Recordings.Access"] as const;

export const ALLOCATION_REPORT_ROLES = ["AllocationReport.Viewer"] as const;

export function hasAnyOfRoles(userRoles: string[], allowedRoles: readonly string[]): boolean {
  if (import.meta.env.VITE_BYPASS_RBAC === "true") return true; // Allow all roles when VITE_BYPASS_RBAC=true in .env file
  if (userRoles.length === 0 || allowedRoles.length === 0) return false;
  return userRoles.some((role) => allowedRoles.includes(role));
}

// Department IDs allowed to see the Underwriting section
export const UNDERWRITING_DEPARTMENTS = [
  "DV"  // Development
] as const satisfies readonly string[];

export const DEALER_DIRECT_QUEUE_DEPARTMENTS = [
  "DV",  // Development
  "DE",  // Dealer Intro 5
] as const satisfies readonly string[];

export const UNDERWRITING_AGENTS = [
  13500,  // Jake Patterson
  14226,  // Thomas Garraty
  13262,  // Caitlin Cooke
  14059,  // Shannon Noon
  12345,  // Adam Ost
  1579,   // Anthony Wonta
  2259,   // Ross Wild
  13654,  // Calum McMillan
  14008,  // Will O'Toole
  12716,  // Roger Cardoso
] as const satisfies readonly number[];

export function hasAnyOfDepartments(userDepartmentId: string | null | undefined, allowedDepartments: readonly string[]): boolean {
  if (import.meta.env.VITE_BYPASS_RBAC === "true") return true;
  if (!userDepartmentId || allowedDepartments.length === 0) return false;
  return allowedDepartments.includes(userDepartmentId);
}

export function hasAnyOfAgentIds(userAgentId: number | null | undefined, allowedAgentIds: readonly number[]): boolean {
  if (import.meta.env.VITE_BYPASS_RBAC === "true") return true;
  if (userAgentId == null || allowedAgentIds.length === 0) return false;
  return (allowedAgentIds as readonly number[]).includes(userAgentId);
}
